import React, {useEffect, useState} from 'react';
import './AddMultiProduct.scss';
import AddProductMulti from "./AddProductMulti/AddProductMulti";
import AddColorMulti from "./AddColorMulti/AddColorMulti";
import AddSizeMulti from "./AddSizeMulti/AddSizeMulti";
import MultiTableProduct from "./MultiTabelProduct/MultiTableProduct";
import _axios from "../../httpService"
import Button from "../UI/Button";
import LabelInput from "./LabelInput/LabelInput";
import TitleWithLine from "./TitleWithLine/TitleWithline";
import {toast} from "react-toastify";
import NumericFunction from "../../utils/NumericFunction";
import commaSeparator from "../../utils/CommaSeparator";
import utilsFunction from "../../utils/utilsFunction";
import Loader from "../Loader";
import {useLocation} from "react-router-dom";
import {prefixUrl} from "../../utils/utilsData";

const AddMultiProduct = () => {

  const myLocation = useLocation();
  const [pageData, setPageData] = useState([]);
  const [forBack, setForBack] = useState([]);
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(true)
  const [sendData, setSendData] = useState({
    kala: {
      Anbar: "",
      AnbarId: "",
      GroupKala: "",
      GroupKalaId: "",
      NameKala: "",
    },
    rang: [],
    size: [],
    Price: '',
    sendToSite: 1,
  });

  useEffect(() => {
    _axios.get(prefixUrl() + "/kalaEntity/?request=entity").then((response) => {
      if (response.data.status) {
        setPageData(response.data.data)
        if (myLocation.state.id) {
          _axios.get(prefixUrl() + "/kalaEntity/?request=submittedData&seriesId=" + myLocation.state.id).then((editData) => {
            if (editData?.data.status) {
              setForBack(editData?.data.data?.submittedProduct)
              setSendData({
                ...sendData,
                ...editData?.data?.data?.overallData,
                seriesId: myLocation.state.id,
                submittedProductFromBack: editData?.data.data?.submittedProduct
              })
              setShow(true)
              setLoading(false)
            } else {
              toast.error(response?.data?.message)
            }
          })
        } else {
          setLoading(false)
        }
      } else {
        toast.error(response?.data?.message)
      }
    })
  }, [])

  const OpenMultiTable = () => {

    let flag = 0;
    setShow(true)

    if (sendData.kala.NameKala === "") {
      toast.error("لطفا نام کالا را وارد کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }
    if (sendData.kala.GroupKala.length === 0) {
      toast.error("لطفا گروه کالا را انتخاب کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }
    if (sendData.kala.Anbar.length === 0) {
      toast.error("لطفا نوع انبار گردانی را انتخاب کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }
    if (sendData.rang.length === 0) {
      toast.error("لطفا رنگ را انتخاب کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }
    if (sendData.size.length === 0) {
      toast.error("لطفا سایز را انتخاب کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }

    if (sendData.Price === '') {
      toast.error("لطفا مبلغ را وارد کنید")
      setShow(false)
      return;
    } else {
      flag = flag + 1
    }

    if (flag === 6) {

      const temp = [];
      sendData.rang.forEach((singleColor, indexRang) =>
        sendData.size.forEach((singleSize, indexSize) => {
          temp.push({
            color: singleColor.label,
            colorId: singleColor.value,
            size: singleSize.label,
            sizeId: singleSize.value,
            NameKala: sendData.kala.NameKala,
            GroupKala: sendData.kala.GroupKala,
            GroupKalaId: sendData.kala.GroupKalaId,
            Anbar: sendData.kala.Anbar,
            AnbarId: sendData.kala.AnbarId,
            price: sendData.Price,
            internetId: "",
            uniqId: "" + indexRang + indexSize,
          })
        })
      )
      setForBack(temp)
    }
  }

  const inputPriceHandler = (e) => {
    const temp = {...sendData}
    temp["Price"] = NumericFunction.p2e(utilsFunction.removeComma(e.target.value))
    setSendData(temp);
  }

  try {
    return (
      <div className={' submit_document_form_class py-2 px-4'}
           style={{'width': '100%', margin: '0 auto', 'height': '98vh', 'overflow': 'scroll', fontSize: 13,}}>
        <div className="main-multi-product">
          {loading ? <Loader/> :
            <>
              <AddProductMulti ProducData={pageData} sendData={sendData} setSendData={setSendData}/>

              <AddColorMulti ProducData={pageData} sendData={sendData} setSendData={setSendData}/>

              <AddSizeMulti ProducData={pageData} sendData={sendData} setSendData={setSendData}/>

              {pageData.access &&
                <div className="main-te-price">
                  <TitleWithLine title="تعریف قیمت" LineClass="line-solid"/>

                  <div className="te-price">
                    <LabelInput
                      labelText="قیمت"
                      onChange={inputPriceHandler}
                      id={"text"}
                      value={"" + NumericFunction.e2p(commaSeparator(sendData?.Price)) + ""}
                      type={"text"}
                      placeholder={"قیمت پیش فرض"}
                      className={"font-changer"}/>
                  </div>
                </div>
              }

              <div className="button-center">
                <Button color={'pBtn'} onClick={OpenMultiTable}>{myLocation.state.id ? "ویرایش" : "افزودن"}</Button>
              </div>
            </>}
        </div>

        <MultiTableProduct forBack={forBack}
                           setForBack={setForBack}
                           show={show}
                           sendData={sendData}/>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default AddMultiProduct;
